module.exports = __webpack_public_path__ + "img/qumo-2.64cc8156.png";